module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_troms_og_finnmark_pos.48fd675b.svg";